import Vue from 'vue';
import find from 'lodash/find';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import {
  UPDATE_RT_DETAILS,
  PUBLISH_RT,
  REPLACE_SUBMISSION,
  ADD_SUBMISSION_COMMENT,
  UPDATE_COMMENT,
  UPDATE_SUBMISSION_SEEN_BY,
  UPDATE_COMMENT_FLAG,
  UPDATE_REPLY_FLAG,
  POST_CLASS_SUMMARY,
  POST_SUBMISSION_SUMMARY,
  POST_DRAFT_EVALUATION,
  POST_EVALUATION,
  SET_LOADING_SAVING_RT,
  JOIN_STUDENTS,
  REMOVE_STUDENTS_RT,
  REMOVE_STUDENT_RT,
  UPDATE_STAR_COUNT,
  UPDATE_STAR_COUNT_SUMMARY,
  SET_ONLINE_ROUNDTABLES_LOADING,
  EDIT_SUBMISSION_CONTENT,
  UPDATE_SUBMISSION_SPREAD,
  TOGGLE_REVEAL_NAMES,
  ADD_SUBMISSION_POINT,
  REMOVE_SUBMISSION_POINT,
  LOADING_SUBMISSION_COMMENTS,
  UPDATE_SUBMISSION_ASSESSMENT,
  UPDATE_SUBMISSION_DRAFT_ASSESSMENT,
  CHANGE_CRITERIA_ASSESSMENT_POINT,
  UPDATE_ROUNDTABLE_KEYWORDS,
  UPDATE_ROUNDTABLE_PLAGIARISM_SCORES,
  USER_ENTERED_SUMMARY_OVERLAY,
  ACTIVE_RT,
  RESET_ROUNDTABLE_GRADES,
  SET_RECENT_ROUNDTABLES,
  UPDATE_RECENT_ROUNDTABLES,
  DELETE_RECENT_RT,
  MARK_ROUNDTABLE_AS_OPENED,
  INCREMENT_SUBMISSION_COMMENT_COUNT,
  SET_GENIE_RECAP,
  SET_GENIE_RECAP_COMMENTS,
  INCREMENT_RECAP_COMMENT_COUNT,
  ADD_RECAP_COMMENT,
  UPDATE_GENIE_RECAP,
  DELETE_GENIE_RECAP,
  CHANGE_CRITERIA_FEEDBACK
} from 'store/mutation-types';

import { defaultState } from './onlineRoundtables.defaultState';

const addCommentToList = (new_comment, commentList) => {
  if (!Array.isArray(commentList)) {
    return;
  }
  const commentExists = find(
    commentList,
    (comment) => comment.id === new_comment.id
  );
  if (!commentExists) {
    commentList.push(new_comment);
  }
};

const findSubmission = (state, submission_id) => {
  return find(
    state.currentRT.submissions,
    (submission) => submission.id === submission_id
  );
};

const $submissions = {
  entryByID: function entry(state, id) {
    const $index = state.currentRT.submissions.findIndex((s) => s.id === id);
    return $index !== -1 ? state.currentRT.submissions[$index] : null;
  },
  comment: function comment(submission, commentID) {
    const $index = submission.comments.findIndex((c) => c.id === commentID);
    return $index !== -1 ? submission.comments[$index] : null;
  },
};

const $genieRecap = {
  comment: function comment(genie_recap, commentID) {
    const $index = genie_recap.comments.findIndex((c) => c.id === commentID);
    return $index !== -1 ? genie_recap.comments[$index] : null;
  },
};
/**
 * EXPORT DEFAULT
 */
export default {
  [UPDATE_RT_DETAILS](state, updatedKeys) {
    if (updatedKeys) {
      const updated_record = Object.assign({}, state.currentRT, updatedKeys);
      const { peer_rewards } = updated_record.points_settings;
      updated_record.points_settings.peer_rewards = peer_rewards.filter((point) => point);
      Vue.set(state, 'currentRT', updated_record);
    }
  },
  [PUBLISH_RT](state) {
    state.currentRT.is_published = true;
    return state;
  },
  [ACTIVE_RT](state) {
    state.currentRT.is_ended = false;
    return state;
  },
  [REPLACE_SUBMISSION](state, submissionDetail) {
    submissionDetail.comment_count = '0';
    const index = state.currentRT.submissions.findIndex((submission) => submission.id === submissionDetail.id);
    if (index !== -1) {
      Object.assign(state.currentRT.submissions[index], submissionDetail);
    } else {
      state.currentRT.submissions.push(submissionDetail);
    }
    return state;
  },
  [UPDATE_SUBMISSION_SPREAD](state, updates) {
    if (!state.currentRT.submissions) {
      state.currentRT.submissions = [];
    }

    const index = findIndex(state.currentRT.submissions, (s) => updates.id === s.id);
    const updatedSubmission = {
      ...state.currentRT.submissions[index],
      ...updates,
    };

    if (updates.toggled_hidden_state) {
      // If the submission has been hidden, we want to hide all of its comments as
      // well and vice-versa.
      if (updatedSubmission.comments && updatedSubmission.comments.length) {
        const { comments: submission_comments } = updatedSubmission;

        for (let index = 0; index < submission_comments.length; index += 1) {
          const comment = submission_comments[index];
          comment.is_hidden = updatedSubmission.is_hidden;

          if (comment.children && comment.children.length) {
            for (let i = 0; i < comment.children.length; i += 1) {
              const children_comment = comment.children[i];
              children_comment.is_hidden = updatedSubmission.is_hidden;
            }
          }
        }
      }
    }

    if (index !== -1) {
      state.currentRT.submissions.splice(index, 1, updatedSubmission);
    } else {
      Vue.set(state.currentRT.submissions, index, updatedSubmission);
      state.currentRT.submissions.push(updatedSubmission);
      const ordered_submissions = state.currentRT.submissions[index].order_submission.map(index => state.currentRT.submissions[index]);
      state.currentRT.submissions = ordered_submissions;
    }
    return state;
  },
  [REMOVE_STUDENT_RT](state, user_id) {
    const index = state.currentRT.submissions.findIndex(
      (s) => s.user_id === user_id || s.real_id === user_id
    );
    if (index !== -1) {
      state.currentRT.submissions.splice(index, 1);
    }
    return state;
  },
  [JOIN_STUDENTS](state, submissions) {
    let rt_submissions = state.currentRT.submissions.slice();
    rt_submissions.push(...submissions);
    Vue.set(state.currentRT, 'submissions', rt_submissions);
    return state;
  },
  [REMOVE_STUDENTS_RT](state, submissions_ids) {
    let rt_submissions = state.currentRT.submissions.slice();
    rt_submissions = rt_submissions.filter(s => !submissions_ids.includes(s.id));
    Vue.set(state.currentRT, 'submissions', rt_submissions);
    return state;
  },
  /**
   *
   * Submission & Comments Pinning
   *
   */
  [ADD_SUBMISSION_COMMENT](state, new_comment) {
    const is_reply = new_comment.comment_id;
    const submission = findSubmission(state, new_comment.submission_id);
    if (!submission) {
      return state;
    }

    if (is_reply) {
      const parent = find(
        submission.comments,
        (top_level_comment) => top_level_comment.id === new_comment.comment_id
      );
      if (parent) {
        addCommentToList(new_comment, parent.children);
      }
    } else {
      new_comment.children = [];
      addCommentToList(new_comment, submission.comments);
    }

    return state;
  },

  [UPDATE_COMMENT](state, cmt) {
    const { genie_recap } = state.currentRT;
    const submission = $submissions.entryByID(state, cmt.submission_id);
    if (submission) {
      const comment = $submissions.comment(submission, cmt.comment_id);
      if (cmt.delete && !cmt.comment_id) {
        const cmtIndex = submission.comments.findIndex((c) => c.id === cmt.id);
        if (cmtIndex !== -1) {
          submission.comments.splice(cmtIndex, 1);
        }
        return state;
      }
      if (cmt.delete && cmt.comment_id) {
        // delete reply - if comment_id it is a reply
        const cmtIndex = submission.comments.findIndex(
          (c) => c.id === cmt.comment_id
        );
        const replyIndex = submission.comments[cmtIndex].children.findIndex(
          (r) => r.id === cmt.id
        );
        if (replyIndex !== -1 && cmtIndex !== -1) {
          submission.comments[cmtIndex].children.splice(replyIndex, 1);
        }
        return state;
      }
      if (cmt.edit) {
        const cmtIndex = submission.comments.findIndex((c) => c.id === cmt.id);
        submission.comments[cmtIndex].content = cmt.content.trim();

        return state;
      }
      cmt.content = cmt.content.trim();
      comment.children
        ? comment.children.push(cmt)
        : Vue.set(comment, 'children', [cmt]);
    }
    else if (genie_recap.id === cmt.recap_id) {
      const comment = $genieRecap.comment(genie_recap, cmt.comment_id);
      if (cmt.delete && !cmt.comment_id) {
        const cmtIndex = genie_recap.comments.findIndex((c) => c.id === cmt.id);
        if (cmtIndex !== -1) {
          genie_recap.comments.splice(cmtIndex, 1);
        }
        return state;
      }
      if (cmt.delete && cmt.comment_id) {
        // delete reply - if comment_id it is a reply
        const cmtIndex = genie_recap.comments.findIndex(
          (c) => c.id === cmt.comment_id
        );
        const replyIndex = genie_recap.comments[cmtIndex].children.findIndex(
          (r) => r.id === cmt.id
        );
        if (replyIndex !== -1 && cmtIndex !== -1) {
          genie_recap.comments[cmtIndex].children.splice(replyIndex, 1);
        }
        return state;
      }
      if (cmt.edit) {
        const cmtIndex = genie_recap.comments.findIndex((c) => c.id === cmt.id);
        genie_recap.comments[cmtIndex].content = cmt.content.trim();

        return state;
      }
      cmt.content = cmt.content.trim();
      comment.children
        ? comment.children.push(cmt)
        : Vue.set(comment, 'children', [cmt]);
    }

    return state;
  },

  ['SOCKET_UPDATE_COMMENT'](state, updated_comment) {
    const { genie_recap } = state.currentRT;
    const submission = findSubmission(state, updated_comment.submission_id);
    if (submission && submission.comments) {
      if (updated_comment.comment_id) {
        const parent_comment = find(
          submission.comments,
          (comment) => comment.id === updated_comment.comment_id
        );
        const comment_index = findIndex(
          parent_comment.children,
          (comment) => comment.id === updated_comment.id
        );
        Vue.set(parent_comment.children, comment_index, {
          ...parent_comment.children[comment_index],
          ...updated_comment,
        });
      } else {
        const comment_index = findIndex(
          submission.comments,
          (comment) => comment.id === updated_comment.id
        );
        Vue.set(submission.comments, comment_index, {
          ...submission.comments[comment_index],
          ...updated_comment,
        });
      }
    } else if (genie_recap.id === updated_comment.recap_id) {
      if (updated_comment.comment_id) {
        const parent_comment = find(
          genie_recap.comments,
          (comment) => comment.id === updated_comment.comment_id
        );
        const comment_index = findIndex(
          parent_comment.children,
          (comment) => comment.id === updated_comment.id
        );
        Vue.set(parent_comment.children, comment_index, {
          ...parent_comment.children[comment_index],
          ...updated_comment,
        });
      } else {
        const comment_index = findIndex(
          genie_recap.comments,
          (comment) => comment.id === updated_comment.id
        );
        Vue.set(genie_recap.comments, comment_index, {
          ...genie_recap.comments[comment_index],
          ...updated_comment,
        });
      }
    }
  },

  [UPDATE_SUBMISSION_SEEN_BY](state, submissionSeen) {
    const submissionIndex = findIndex(
      state.currentRT.submissions,
      (sub) => sub.id === submissionSeen.id
    );
    const submissionToUpdate = state.currentRT.submissions[submissionIndex];
    submissionToUpdate.seen_by = submissionSeen.seen_by;
    state.currentRT.submissions.splice(submissionIndex, 1, submissionToUpdate);
    return state;
  },
  [UPDATE_COMMENT_FLAG](state, flaggedComment) {
    const { genie_recap } = state.currentRT;
    const submission = find(
      state.currentRT.submissions,
      (sub) => sub.id === flaggedComment.submission_id
    );
    if (submission) {
      const comment = $submissions.comment(submission, flaggedComment.id);
      comment.flagged_by = flaggedComment.flagged_by;
    } else if (genie_recap.id === flaggedComment.recap_id) {
      const comment = $genieRecap.comment(genie_recap, flaggedComment.id);
      comment.flagged_by = flaggedComment.flagged_by;
    }
    return state;
  },
  [UPDATE_REPLY_FLAG](state, flaggedReply) {
    const { genie_recap } = state.currentRT;
    const submission = find(
      state.currentRT.submissions,
      (sub) => sub.id === flaggedReply.submission_id
    );
    if (submission) {
      const comment = $submissions.comment(submission, flaggedReply.comment_id);
      const replyIndex = comment.children.findIndex(
        (c) => c.id === flaggedReply.id
      );
      if (replyIndex !== -1) {
        comment.children[replyIndex].flagged_by = flaggedReply.flagged_by;
      }
    } else if (genie_recap.id === flaggedReply.recap_id) {
      const comment = $genieRecap.comment(genie_recap, flaggedReply.comment_id);
      const replyIndex = comment.children.findIndex(
        (c) => c.id === flaggedReply.id
      );
      if (replyIndex !== -1) {
        comment.children[replyIndex].flagged_by = flaggedReply.flagged_by;
      }
    }
    return state;
  },
  /**
   *
   * Grading
   *
   */
  [POST_CLASS_SUMMARY](state, classSummary) {
    state.grades.summary = classSummary.summary;
    return state;
  },
  [POST_SUBMISSION_SUMMARY](state, studentSummary) {
    state.grades.student = studentSummary;
    return state;
  },
  [POST_DRAFT_EVALUATION](state, { submissionID, draft_evaluation }) {
    const submission_in_state = $submissions.entryByID(state, submissionID);
    state.grades.student.draft_evaluation = draft_evaluation;
    submission_in_state.draft_evaluation = draft_evaluation;
    return state;
  },
  [POST_EVALUATION](state, { submissionID, evaluation }) {
    const submission_in_state = $submissions.entryByID(state, submissionID);
    state.grades.student.evaluation = evaluation;
    state.grades.student.draft_evaluation = evaluation.comment;
    submission_in_state.evaluation = evaluation;
    return state;
  },
  /**
   * loading
   */
  [SET_ONLINE_ROUNDTABLES_LOADING](state, { subState, status }) {
    state.loading[subState] = status;
    return state;
  },
  [SET_LOADING_SAVING_RT](state, status) {
    state.saving = status;
    return state;
  },
  [UPDATE_STAR_COUNT](state, comment) {
    const { genie_recap } = state.currentRT;
    let starred_comment;
    const { starred_by, submission_id, id, comment_id } = comment;
    const submission = $submissions.entryByID(state, submission_id);
    if (submission && submission.comments) {
      // If reply, find parent and then child
      if (comment_id) {
        const parent_comment = $submissions.comment(submission, comment_id);
        starred_comment = find(
          parent_comment.children,
          (child) => child.id === id
        );
      } else {
        starred_comment = $submissions.comment(submission, comment.id);
      }
    } else if (genie_recap.id === comment.recap_id) {
      if (comment_id) {
        const parent_comment = $genieRecap.comment(genie_recap, comment_id);
        starred_comment = find(
          parent_comment.children,
          (child) => child.id === id
        );
      } else {
        starred_comment = $genieRecap.comment(genie_recap, comment.id);
      }
    }

    // Update the starred_by array in the state
    if (starred_comment && starred_comment.starred_by !== comment.starred_by) {
      starred_comment.starred_by = [...starred_by];
    }
    return state;
  },
  [UPDATE_STAR_COUNT_SUMMARY](state, comment) {
    const comments = get(state, 'grades.student.submission.comments');
    const my_comments = get(state, 'grades.student.my_comments');
    if (comments) {
      let comment_in_state;
      if (comment.comment_id) {
        // find parent
        const parent = comments.find((c) => c.id === comment.comment_id);
        comment_in_state = parent.children.find((c) => c.id === comment.id);
      } else {
        comment_in_state = comments.find((c) => c.id === comment.id);
      }
      if (comment_in_state) {
        comment_in_state.starred_by = comment.starred_by;
      }
    }
    if (my_comments) {
      let comment_in_state;
      comment_in_state = my_comments.find((c) => c.id === comment.id);
      if (comment_in_state) {
        comment_in_state.starred_by = comment.starred_by;
      }
    }
    return state;
  },
  [LOADING_SUBMISSION_COMMENTS](state, { id, status }) {
    const loading = state.loading.full_submission;
    if (status && loading.indexOf(id) === -1) {
      loading.push(id);
    } else if (!status && loading.indexOf(id) !== -1) {
      loading.splice(loading.indexOf(id), 1);
    }
    return state;
  },
  [EDIT_SUBMISSION_CONTENT](state, { id, prompt_response, trimmed_prompt_response }) {
    const submission_in_state = $submissions.entryByID(state, id);
    submission_in_state.prompt_response = prompt_response;
    submission_in_state.trimmed_prompt_response = trimmed_prompt_response;
    return state;
  },
  [TOGGLE_REVEAL_NAMES](state, status) {
    state.currentRT.reveal_names = status;
    return state;
  },
  [UPDATE_SUBMISSION_ASSESSMENT](state, { assessments }) {
    state.grades.student.submission.assessments = assessments;
    return state;
  },
  [UPDATE_SUBMISSION_DRAFT_ASSESSMENT](state, { draft_assessments }) {
    state.grades.student.submission.draft_assessments = draft_assessments;
    return state;
  },
  [CHANGE_CRITERIA_ASSESSMENT_POINT](state, { submissionId, criteriaTag, value }) {
    const submission = $submissions.entryByID(state, submissionId);
    const criteriaIndex = submission.draft_assessments.findIndex((a) => a.tag === criteriaTag);
    state.grades.student.submission.draft_assessments[criteriaIndex].value = value;
    return state;
  },
  [CHANGE_CRITERIA_FEEDBACK](state, { submissionId, criteriaTag, feedback }) {
    const submission = $submissions.entryByID(state, submissionId);
    const criteriaIndex = submission.draft_assessments.findIndex((a) => a.tag === criteriaTag);
    state.grades.student.submission.draft_assessments[criteriaIndex].feedback = feedback;
    return state;
  },
  [ADD_SUBMISSION_POINT](state, { submissionID, point }) {
    const submission_in_state = $submissions.entryByID(state, submissionID);
    if (submission_in_state.rewards) {
      submission_in_state.rewards.push(point);
    }
    return state;
  },
  [REMOVE_SUBMISSION_POINT](state, { submissionID, point }) {
    const submission_in_state = $submissions.entryByID(state, submissionID);
    const index = submission_in_state.rewards.findIndex(
      (reward) => reward.id === point.id
    );
    if (index !== -1) {
      submission_in_state.rewards.splice(index, 1);
    }
    return state;
  },
  
  [INCREMENT_SUBMISSION_COMMENT_COUNT](state, submission_id) {
    const submission = findSubmission(state, submission_id);
    submission.comment_count = parseInt(submission.comment_count) + 1;
  },
  [UPDATE_ROUNDTABLE_KEYWORDS](state, roundtable) {

    const { id, keywords } = roundtable;

    if (state.currentRT.id === id) {
      state.currentRT.keywords = keywords;
    }

    return state;
  },
  [UPDATE_ROUNDTABLE_PLAGIARISM_SCORES](state, roundtable) {

    const { id, plagiarism_scores, submissions } = roundtable;

    if (state.currentRT.id === id) {
      state.currentRT.plagiarism_scores = plagiarism_scores;
      state.currentRT.submissions = submissions;
    }

    return state;
  },
  [USER_ENTERED_SUMMARY_OVERLAY](state, value) {
    state.userInSummaryOverlay = value;
    return state;
  },
  [RESET_ROUNDTABLE_GRADES](state) {
    state.grades = JSON.parse(JSON.stringify(defaultState.grades));
    return state;
  },
  [SET_RECENT_ROUNDTABLES](state, { roundtables }) {
    state.recentRtsList = roundtables;
    /* state.recent_participant_roundtables = null;
    state.recent_instructor_roundtables = instructor_roundtables === undefined || instructor_roundtables === null ? [] : instructor_roundtables; */
    return state;
  },
  [DELETE_RECENT_RT](state, id) {
    const index = findIndex(state.recentRtsList, { id });
    if (index !== -1) {
      state.recentRtsList.splice(index, 1);
    }
    return state;
  },
  [MARK_ROUNDTABLE_AS_OPENED](state, id) {
    const rt = find(state.recentRtsList, (rt) => rt.id === id);
    rt.opened = true;
  },
  [UPDATE_RECENT_ROUNDTABLES](state, sequenceUpdated) {
    if (state.recentRtsList) {
      const sequence = state.recentRtsList.find(
        (s) => s.id === sequenceUpdated.data.id
      );
      if (sequence) {
        sequence.title = sequenceUpdated.data.title;
      }
    }
    return state;
  },
  [SET_GENIE_RECAP](state, data) {
    const { roundtable_id } = data;
    if (state.currentRT.id === roundtable_id) {
      if (!data.comment_count) data.comment_count = 0;
      if (!data.submissions_count) data.submissions_count = 0;
      state.currentRT.genie_recap = data;
    } else {
      state.currentRT.genie_recap = {};
    }
    return state;
  },
  [UPDATE_GENIE_RECAP](state, data) {
    const { roundtable_id } = data;
    if (state.currentRT.id === roundtable_id) {
      if (!data.comment_count) data.comment_count = 0;
      state.currentRT.genie_recap = data;
    }
    return state;
  },
  [DELETE_GENIE_RECAP](state, data) {
    const { roundtable_id } = data;
    if (state.currentRT.id === roundtable_id) {
      state.currentRT.genie_recap = {};
    }
    return state;
  },
  [SET_GENIE_RECAP_COMMENTS](state, recap_comments) {
    const { genie_recap } = state.currentRT;
    if (genie_recap.id === recap_comments.id) {
      genie_recap.comments = recap_comments.data;
    }
    return state;
  },
  [INCREMENT_RECAP_COMMENT_COUNT](state, new_comment) {
    const { genie_recap } = state.currentRT;
    if (genie_recap.id === new_comment.recap_id) {
      genie_recap.comment_count = parseInt(genie_recap.comment_count) + 1;
    }
  },
  [ADD_RECAP_COMMENT](state, new_comment) {
    const { genie_recap } = state.currentRT;
    const is_reply = new_comment.comment_id;
    if (genie_recap.id === new_comment.recap_id) {
      if (is_reply) {
        const parent = find(
          genie_recap.comments,
          (top_level_comment) => top_level_comment.id === new_comment.comment_id
        );
        if (parent) {
          addCommentToList(new_comment, parent.children);
        }
      } else {
        new_comment.children = [];
        addCommentToList(new_comment, genie_recap.comments);
      }
    }
    return state;
  },
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.mutations.js